import clsx from "clsx"
import { forwardRef } from "react"
import {
  SessionScheduleBtn,
  SessionScheduleBtnDate,
  SessionScheduleBtnTitle
} from "./styles"

interface ISessionScheduleTabProps {
  isActive?: boolean
  onClick?: () => void
  tab?: {
    id: number
    title: string
    date: string
  }
}

export const SessionScheduleTab = forwardRef<
  HTMLButtonElement,
  ISessionScheduleTabProps
>(({ isActive, onClick, tab }, ref) => {
  return (
    <SessionScheduleBtn
      className={clsx({ active: isActive })}
      onClick={onClick}
      ref={isActive ? ref : undefined}
    >
      <SessionScheduleBtnTitle>{tab?.title}</SessionScheduleBtnTitle>
      <SessionScheduleBtnDate>{tab?.date}</SessionScheduleBtnDate>
    </SessionScheduleBtn>
  )
})

SessionScheduleTab.displayName = "SessionScheduleTab"
